export enum TariffStatus {
  Ready = 'READY',
  Wait = 'WAIT',
  Error = 'ERROR',
}
